import { MEMBER_DASH_TAB_ICONS } from "@/lib/navIcons";

/** Clé onglet vue d’ensemble du tableau de bord membre. */
export const DASH_OVERVIEW_TAB = "overview";

export { MEMBER_DASH_TAB_ICONS };

/** Rubriques « Activité marché » (sidebar membre) — badges optionnels via `buildMemberDashboardNav`. */
export const MEMBER_DASH_NAV_BASE = [
  { tab: DASH_OVERVIEW_TAB, label: "Vue d'ensemble", testId: "tab-overview" },
  { tab: "buys", label: "Mes achats", testId: "tab-buys" },
  { tab: "sales", label: "Mes ventes", testId: "tab-sales" },
  { tab: "annonces", label: "Mes annonces", testId: "tab-annonces" },
  { tab: "suggestions", label: "Suggestions", testId: "tab-suggestions" },
  { tab: "negotiations", label: "Négociations", testId: "tab-negotiations" },
  { tab: "disputes", label: "Litiges", testId: "tab-disputes" },
  { tab: "invoices", label: "Factures", testId: "tab-invoices" },
];

/** Fusionne les pastilles « nouveau » du tableau de bord sur la nav sidebar. */
export function buildMemberDashboardNav(hasNewByTab = {}) {
  return MEMBER_DASH_NAV_BASE.map((row) => ({
    ...row,
    badge: row.tab === "invoices" ? false : Boolean(hasNewByTab?.[row.tab]),
  }));
}
